import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-list\"><path fill=\"#333333\" d=\"M286.72 579.584h737.28v155.648H286.72z m0-289.792h506.88v155.648H286.72zM0 868.352h168.96V1024H0zM286.72 0h737.28v155.648H286.72z m0 868.352h629.76V1024H286.72zM0 0h168.96v155.648H0z m0 579.584h168.96v155.648H0z m0-289.792h168.96v155.648H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol